export const TabsStyle = {
  ON_CARD: 'onCard',
  ON_PAGE: 'onPage',
};
